import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

// ================ Action types ================ //

export const QUERY_BOOKINGS_REQUEST = 'app/ManageBookingsPage/QUERY_BOOKINGS_REQUEST';
export const QUERY_BOOKINGS_SUCCESS = 'app/ManageBookingsPage/QUERY_BOOKINGS_SUCCESS';
export const QUERY_BOOKINGS_ERROR = 'app/ManageBookingsPage/QUERY_BOOKINGS_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  transactionRefs: [],
  pagination: null,
  queryInProgress: false,
  queryBookingsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case QUERY_BOOKINGS_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryBookingsError: null,
      };

    case QUERY_BOOKINGS_SUCCESS:
      return {
        ...state,
        transactionRefs: entityRefs(payload.data.data),
        pagination: payload.data.meta,
        queryInProgress: false,
      };

    case QUERY_BOOKINGS_ERROR:
      return {
        ...state,
        transactionRefs: [],
        pagination: null,
        queryInProgress: false,
        queryBookingsError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const queryBookingsRequest = () => ({ type: QUERY_BOOKINGS_REQUEST });

export const queryBookingsSuccess = response => ({
  type: QUERY_BOOKINGS_SUCCESS,
  payload: response,
});

export const queryBookingsError = e => ({
  type: QUERY_BOOKINGS_ERROR,
  payload: e,
  error: true,
});

// ================ Thunk ================ //

export const queryBookings = () => (dispatch, getState, sdk) => {
  dispatch(queryBookingsRequest());

  // `only: 'order'` returns the transactions where the current user is the
  // customer (renter). Listing/provider/booking are included and stored in the
  // shared marketplaceData entities via addMarketplaceEntities, so the component
  // can read fully denormalised entities (title, image, dates) from them.
  const apiQueryParams = {
    only: 'order',
    include: ['listing', 'listing.images', 'provider', 'provider.profileImage', 'booking'],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
    ],
    'fields.listing': ['title', 'publicData.listingType'],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.listing-card',
      'variants.listing-card-2x',
    ],
  };

  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(queryBookingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(queryBookingsError(storableError(e)));
      throw e;
    });
};

// ================ Page load data ================ //

export const loadData = (params, search) => dispatch => {
  return dispatch(queryBookings());
};
